module.exports = __webpack_public_path__ + "prod/1.42.2/img/new-mode-two.7ed2f681.png";